module.exports = __webpack_public_path__ + "media/images/icon_arrow_gray-f69ebc56a9427c2e8517010cc8c9468f.svg";